import { FuseNavigationItem } from '@fuse/components/navigation';
import { PermissionKeys } from 'app/config/permissions-key';
import { environment } from 'environments/environment';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'dashboards.analytics',
                title: 'Operations',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/dashboards/analytics',
                meta: {
                    permission: PermissionKeys.AnalyticsViewKey
                }
            },
            {
                id: 'dashboards.finance',
                title: 'Finance',
                type: 'basic',
                icon: 'heroicons_outline:banknotes',
                link: '/dashboards/finance',
                meta: {
                    permission: PermissionKeys.FinanceViewKey
                }
            },
        ],
    },
    {
        id: 'operations',
        title: 'Operations',
        type: 'group',
        icon: 'heroicons_outline:clipboard-document-list',
        children: [
            {
                id: 'operations.quotation',
                title: 'Quotations',
                type: 'basic',
                icon: 'heroicons_outline:document-check',
                link: '/operations/quotation',
                meta: {
                    permission: PermissionKeys.QuotationViewKey
                }
            },
            {
                id: 'operations.po',
                title: 'Purchase Orders',
                type: 'basic',
                icon: 'heroicons_outline:inbox-arrow-down',
                link: '/operations/purchase-order',
                meta: {
                    permission: PermissionKeys.POsViewKey
                }
            },
            {

                id: 'operations.jobs',
                title: 'Jobs',
                type: 'basic',
                icon: 'heroicons_outline:rocket-launch',
                link: '/operations/jobs',
                meta: {
                    permission: PermissionKeys.ShipmentsViewKey
                }
            }
        ],
    },
    {
        id: 'finance',
        title: 'Finance',
        type: 'group',
        children: [
            {
                id: 'finance.invoice',
                title: 'Invoice',
                type: 'basic',
                icon: 'heroicons_outline:document-text',
                link: '/finance/invoice',
                meta: {
                    permission: PermissionKeys.InvoicesViewKey
                }
            },
            {
                id: 'finance.dolphin-upload',
                title: 'Dolphin Upload',
                type: 'basic',
                icon: 'heroicons_outline:cloud-arrow-up',
                link: '/finance/dolphin-upload',
                meta: {
                    permission: PermissionKeys.DolphinUploadViewKey
                }
            },

        ],
    },
    {
        id: 'admininstration',
        title: 'Administration',
        icon: 'heroicons_outline:document-text',
        type: 'group',
        children: [
            {
                id: 'master-data',
                title: 'Masters',
                icon: 'heroicons_outline:circle-stack',
                type: 'collapsable',
                meta: {
                    permission: PermissionKeys.MasterDataKey
                },
                children: [
                    {
                        id: 'agents',
                        title: 'Agents',
                        link: 'master-data/agents',
                        externalLink: false,
                        target: '_blank',
                        type: 'basic',
                        meta: {
                            permission: PermissionKeys.AgentsViewKey
                        }
                    },
                    {
                        id: 'branches',
                        title: 'Branches',
                        link: "master-data/branches",
                        externalLink: false,
                        target: '_blank',
                        type: 'basic',
                        meta: {
                            permission: PermissionKeys.BranchesViewKey
                        }
                    },
                    {
                        id: 'exchange-rates',
                        title: 'Exchange Rates',
                        link: "master-data/exchange-rates",
                        externalLink: false,
                        target: '_blank',
                        type: 'basic',
                        meta: {
                            permission: PermissionKeys.ExchangeRatesViewKey
                        }
                    },
                    {
                        id: 'payment-type',
                        title: 'Payment Type',
                        link: "master-data/payment-type",
                        externalLink: false,
                        target: '_blank',
                        type: 'basic',
                        meta: {
                            permission: PermissionKeys.PaymentTypeViewKey
                        }
                    },
                    {
                        id: 'port',
                        title: 'Port',
                        link: "master-data/port",
                        externalLink: false,
                        target: '_blank',
                        type: 'basic',
                        meta: {
                            permission: PermissionKeys.PortViewKey
                        }
                    },
                    {
                        id: 'customers',
                        title: 'Customers',
                        link: "master-data/customer",
                        externalLink: false,
                        target: '_blank',
                        type: 'basic',
                        meta: {
                            permission: PermissionKeys.PrincipalsViewKey
                        }
                    },
                    {
                        id: 'service',
                        title: 'Services',
                        link: "master-data/service",
                        externalLink: false,
                        target: '_blank',
                        type: 'basic',
                        meta: {
                            permission: PermissionKeys.ServicesViewKey
                        }
                    },
                    {
                        id: 'services-template',
                        title: 'Service Template',
                        link: "master-data/service-template",
                        externalLink: false,
                        target: '_blank',
                        type: 'basic',
                        meta: {
                            permission: PermissionKeys.ServiceTemplateViewKey
                        }
                    },
                    {
                        id: 'suppliers',
                        title: 'Suppliers',
                        link: "master-data/suppliers",
                        externalLink: false,
                        target: '_blank',
                        type: 'basic',
                        meta: {
                            permission: PermissionKeys.SuppliersViewKey
                        }
                    },
                    {
                        id: 'tax-types',
                        title: 'Tax Types',
                        link: "master-data/tax",
                        externalLink: false,
                        target: '_blank',
                        type: 'basic',
                        meta: {
                            permission: PermissionKeys.TaxTypesViewKey
                        }
                    },
                    {
                        id: 'users',
                        title: 'Users',
                        link: "master-data/users",
                        externalLink: false,
                        target: '_blank',
                        type: 'basic',
                        meta: {
                            permission: PermissionKeys.UsersViewKey
                        }
                    },
                    {
                        id: 'vessels',
                        title: 'Vessels',
                        link: "master-data/vessels",
                        externalLink: false,
                        target: '_blank',
                        type: 'basic',
                        meta: {
                            permission: PermissionKeys.VesselsViewKey
                        }
                    }
                ]
            },
            {
                id: 'configuration',
                title: 'Configurations',
                icon: 'heroicons_outline:cog-6-tooth',
                type: 'collapsable',
                children: [
                    {
                        id: 'eyeshare-config',
                        title: 'Eyeshare Configuration',
                        type: 'basic',
                        externalLink: true,
                        target: '_blank',
                        link: environment.operationsModuleUrl + "invoiceconfiguration",
                        meta: {
                            permission: PermissionKeys.EyeshareConfigurationViewKey
                        }
                    },
                    {
                        id: 'permissions.roles',
                        title: 'Roles and Permissions',
                        type: 'basic',
                        link: '/configurations/permissions',
                        meta: {
                            permission: PermissionKeys.RolesPermissionViewKey
                        }
                    },
                    {
                        id: 'application-config',
                        title: 'Application Configuration',
                        type: 'basic',
                        link: '/configurations/applicationconfiguration',
                        meta: {
                            permission: PermissionKeys.ApplicationConfigurationViewKey
                        }
                    },
                    {
                        id: 'invoice-approval-config',
                        title: 'Invoice Configuration',
                        type: 'basic',
                        link: '/configurations/invoice-approval-configuration',
                        meta: {
                            permission: PermissionKeys.InvoiceApprovalConfigurationViewKey
                        }
                    }
                ],
            },
        ],
    },
    {
        id: 'reports',
        title: 'Reports',
        icon: 'heroicons_outline:document-text',
        type: 'group',
        children: [
            {
                id: 'invoice-report',
                title: 'Invoice Report',
                type: 'basic',
                link: "reports/invoice-report",
                icon: 'heroicons_outline:document-check',
                meta: {
                    permission: PermissionKeys.InvoiceReportViewKey
                }
            },
            {
                id: 'static-reports',
                title: 'Static Reports',
                type: 'collapsable',
                icon: 'heroicons_mini:chart-bar',
                children: [
                    {
                        id: 'stock-report',
                        title: 'Stock Report',
                        type: 'basic',
                        externalLink: true,
                        target: '_blank',
                        link: environment.operationsModuleUrl + "stockreport",
                        meta: {
                            permission: PermissionKeys.StockReportViewKey
                        }
                    },
                    {
                        id: 'sustainability-report',
                        title: 'Sustainability Report',
                        type: 'basic',
                        externalLink: true,
                        target: '_blank',
                        link: environment.operationsModuleUrl + "operationreport",
                        meta: {
                            permission: PermissionKeys.OperationReportViewKey
                        }
                    }
                ],
            },
            {
                id: 'custom-reports',
                title: 'Custom Reports',
                type: 'collapsable',
                icon: 'heroicons_mini:chart-bar',
                children: [
                    {
                        id: 'operations-report',
                        title: 'Operations Report',
                        type: 'basic',
                        link: 'reports/operational-report',
                        meta: {
                            permission: PermissionKeys.OperationalReportViewKey
                        }
                    },
                    {
                        id: 'stock-report',
                        title: 'Stock Report',
                        type: 'basic',
                        externalLink: true,
                        target: '_blank',
                        link: environment.operationsModuleUrl + 'stockreport',
                        meta: {
                            permission: PermissionKeys.StockReportViewKey
                        }
                    },
                ],
            },
        ],
    },
];
